import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import * as globalFunction from 'util/GlobalFunction';

export function onModuleChange({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ defaultFormData: { moduleId: parameter }, moduleId: parameter });
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  sectionComponent.setState({ componentDefaultValue });

  sectionComponent.child.map((child, i) => {
    child.current?.setState({ moduleId: parameter });
  })

  httpClient
    .get('/Admin/Lga/GetSelectOptionList?moduleId=' + parameter)
    .then(({ data }) => {
      if (data.result) {
        let componentDataSource = { ...sectionComponent.state.componentDataSource };
        componentDataSource['LgaId'] = data.data;
        sectionComponent.setState({ componentDataSource });

        sectionComponent.child.map((child, i) => {
          if (child.current?.customForm.current !== null) {
            let componentDataSource = { ...child.current?.customForm.current?.state.componentDataSource };
            let componentDefaultValue = { ...child.current?.customForm.current?.state.componentDefaultValue };
            componentDataSource['LgaId'] = data.data;
            componentDefaultValue['LgaId'] = data.data[0].Value;
            child.current?.customForm.current?.setState({ componentDataSource, componentDefaultValue });
          }
        })
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });

  httpClient
    .get('/Admin/AppIntegration/GetAccountCode?moduleId=' + parameter)
    .then(({ data }) => {
      if (data.result) {
        let componentDataSource = { ...sectionComponent.state.componentDataSource };
        componentDataSource['AccountCode'] = data.data;
        sectionComponent.setState({ componentDataSource });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });

  httpClient
    .get('Admin/FeeRate/GetSelectOptionList')
    .then(({ data }) => {
      if (data.result) {
        if (data.data.length > 0) {
          let componentDataSource = { ...sectionComponent.state.componentDataSource };
          let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
          componentDataSource['FeeRateId'] = data.data;
          componentDefaultValue['FeeRateId'] = data.data[0].Value;
          sectionComponent.setState({ componentDataSource, componentDefaultValue });
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });

  httpClient
    .get('/Admin/JobType/GetSelectOptionList?moduleId=' + parameter)
    .then(({ data }) => {
      if (data.result) {
        if (data.data.length > 0) {
          let componentDataSource = { ...sectionComponent.state.componentDataSource };
          let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
          componentDataSource['JobTypeId'] = data.data;
          componentDefaultValue['JobTypeId'] = data.data[0].Value;
          sectionComponent.setState({ componentDataSource, componentDefaultValue });
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });

  getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie });
}

export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  //Tab组件里, sectionComponent.child.current 是对应的渲染分选组件
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  sectionComponent.setState({ componentDefaultValue });

  setTimeout(() => {
    sectionComponent.child.map((child, i) => {
      if (child.current != null) {
        let searchParameter = {};
        searchParameter.moduleId = pageComponent.state.defaultFormData.moduleId;
        if (componentDefaultValue['FeeRateId'] !== undefined) {
          searchParameter.feeRateId = componentDefaultValue['FeeRateId'];
        }
        if (componentDefaultValue['JobTypeId'] !== undefined) {
          searchParameter.jobTypeId = componentDefaultValue['JobTypeId'];
        }

        child.current?.setState({ searchParameter });
        child.current?.child.current?.setState({ moduleId: pageComponent.state.defaultFormData.moduleId });

        if (child.current?.customForm.current != null) {
          child.current?.customForm.current?.setState({ componentDataSource: [] });
        }

        setTimeout(() => {
          child.current?.getSectionDataByDefault();
        }, config.setTimeoutMilliSecond);
      }
    })
  }, config.setTimeoutMilliSecond);
}

export function addLineItemGroup({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.child.map((child, i) => {
    if (child.current != null && child.current?.child.current?.props.sectionName === 'LineItem') {
      child.current?.child.current?.setState({ manageGroupShow: true, manageGroupComponentType: 'Create' });
      setTimeout(() => {
        child.current?.child.current?.manageGroup.current?.formRef.current?.setFieldValue('LgaId', sectionComponent.state.componentDataSource.LgaId[0].Value);
      }, config.setTimeoutMilliSecond);
    }
  })
}

export function editLineItemGroup({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ manageGroupShow: true, manageGroupComponentType: 'Edit', lineItemGroupId: parameter.LineItemGroupId });
  setTimeout(() => {
    httpClient
      .get('/Admin/LineItemGroup/' + parameter.LineItemGroupId)
      .then(({ data }) => {
        console.log(data);
        if (data.result) {
          if (data.data['LgaId'] === null) {
            data.data['LgaId'] = 0;
          }
          sectionComponent.manageGroup.current?.formRef.current?.setFieldsValue(data.data);
          sectionComponent.manageGroup.current?.setState({ formData: data.data });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }, config.setTimeoutMilliSecond);
}

export function deleteLineItemGroup({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  httpClient
    .delete('/Admin/LineItemGroup/' + parameter)
    .then(({ data }) => {
      if (data.result) {
        sectionComponent.getSectionDataByDefault();
      } else {
        message.error(data.message);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function addLineItem({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Create' });
  setTimeout(() => {
    //设置默认选择的Group
    let formData = parameter;
    formData.UnitAmount = 0;
    sectionComponent.customForm.current?.formRef.current?.setFieldsValue(formData);
    sectionComponent.customForm.current?.setState({ formData });

    setTimeout(() => {
      let componentDataSource = { ...sectionComponent.customForm.current?.state.componentDataSource };
      if (sectionComponent.props.sectionComponent.state.componentDataSource['AccountCode'] != null && sectionComponent.props.sectionComponent.state.componentDataSource['AccountCode'].length > 0) {
        componentDataSource['AccountCode'] = sectionComponent.props.sectionComponent.state.componentDataSource['AccountCode'];
        sectionComponent.customForm.current?.setState({ componentDataSource });
        sectionComponent.customForm.current?.formRef.current?.setFieldValue('AccountCode', componentDataSource['AccountCode'][0].Value);
        globalFunction.setUieVisible(pageComponent, 'LineItem', 'Create', 'AccountCode', true);
      } else {
        globalFunction.setUieVisible(pageComponent, 'LineItem', 'Create', 'AccountCode', false);
      }

      //设置联动的Select
      getLineItemGroupSelectOptionList({ sectionName: sectionName, parameter: parameter.LineItemFolderId, formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent });
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

export function editLineItemPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  setTimeout(() => {
    let componentDataSource = { ...sectionComponent.customForm.current?.state.componentDataSource };
    if (sectionComponent.props.sectionComponent.state.componentDataSource['AccountCode'] != null && sectionComponent.props.sectionComponent.state.componentDataSource['AccountCode'].length > 0) {
      componentDataSource['AccountCode'] = sectionComponent.props.sectionComponent.state.componentDataSource['AccountCode'];
      sectionComponent.customForm.current?.setState({ componentDataSource });
      globalFunction.setUieVisible(pageComponent, 'LineItem', 'Edit', 'AccountCode', true);
    } else {
      globalFunction.setUieVisible(pageComponent, 'LineItem', 'Edit', 'AccountCode', false);
    }

    //设置联动的Select
    getLineItemGroupSelectOptionList({ sectionName: sectionName, parameter: parameter.LineItemFolderId, formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent });
  }, config.setTimeoutMilliSecond);
}

export function getLineItemGroupSelectOptionList({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .get('Admin/LineItemGroup/GetSelectOptionList?moduleId=' + formComponent.props.moduleId)
    .then(({ data }) => {
      if (data.result) {
        let dataSource = data.data;
        let componentDataSource = { ...formComponent.state.componentDataSource };
        componentDataSource['LineItemGroupId'] = dataSource;
        formComponent.setState({ componentDataSource });
        if (dataSource.length > 0) {
          if (dataSource.filter(item => item.Value === sectionComponent.customForm.current?.formRef.current?.getFieldValue('LineItemGroupId')).length === 0) {
            sectionComponent.customForm.current?.formRef.current?.setFieldValue('LineItemGroupId', dataSource[0].Value);
          } else {
            //否则选择当前值
            sectionComponent.customForm.current?.formRef.current?.setFieldValue('LineItemGroupId', sectionComponent.customForm.current?.formRef.current?.getFieldValue('LineItemGroupId'));
          }
        } else {
          //搜不到数据源, 移除Group
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('LineItemGroupId', null);
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function accountCodeChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  let accountCode = sectionComponent.props.sectionComponent.state.componentDataSource['AccountCode'].filter(c => c.Value === parameter);
  if (accountCode.length > 0) {
    sectionComponent.customForm.current?.formRef.current?.setFieldValue('Tax', accountCode[0].Data);
  }
}

export function collapseAllGroups({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  const newCollapseStates = {};
  sectionComponent.child.forEach((child, i) => {
    if (child.current != null && child.current?.child.current?.props.sectionName === 'LineItem') {
      const currentCollapseStates = child.current?.child.current.state.groupCollapseStates || {};
      child.current?.child.current.child.forEach((group, j) => {
        const groupKey = group.current.props.data.key;
        newCollapseStates[groupKey] = true;
      });
      child.current?.child.current.setState({
        groupCollapseStates: newCollapseStates
      });
    }
    });
}

//LineItem列表下载Excel
export function exportToExcel({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.download({ method: 'post', url: '/Admin/LineItem/GenerateExcel?moduleId=' + pageComponent.state.defaultFormData.moduleId, filename: 'Line Item.xlsx', save: true });
}
